var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('DiceItem',{attrs:{"label":_vm.defenseLabel,"dice":_vm.defense}}),_c('br'),_c('ArmorItem',{attrs:{"armor":_vm.armor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }